import { IAttendancesVotes, VoteType } from "@grassrootly/api/entities";
import { provider } from "@grassrootly/api/providers";

export type SubmitPlayerGameVotesPayload = {
  votes: Array<{
    id: number;
    attendanceId: number;
    type: VoteType;
  }>;
};

export const SubmitPlayerGameVotes = async (params: SubmitPlayerGameVotesPayload): Promise<IAttendancesVotes[]> =>
  provider.Request("/players/{id}/attendance/{attendanceId}", params);
